import React from 'react'
import p46 from '../../media/Content/Media/39.1.jpg'
import {Image} from 'react-bootstrap'
function Kod39() {
  return (
    <Image src={p46} style={{width:'100%'}}/>
  )
}

export default Kod39